<div class="cardModal">
    <div class="cardTitle">
        <h3>{{ 'users.shijiUsers.edit.title' | translate }}</h3>
    </div>
    <div class="cardContentStretched">
        <app-tab-outline [tabs]="tabs" (selectedTabIndexChange)="selectTab($event)" />
    </div>
    <div class="cardFooter">
        <div class="buttonArea stickyBottom">
            @let mainButtonLabelValue = mainButtonLabel();
            @if (mainButtonLabelValue) {
                <button type="submit" class="button primary" (click)="modalMainButtonAction()">
                    {{ mainButtonLabelValue | translate }}
                </button>
            }
            <button type="button" class="button" (click)="closeModal()">{{ 'users.shijiUsers.edit.cancel' | translate }}</button>
        </div>
    </div>
</div>
